// import Qs from "qs"
import { Ajax } from "../utils/base.js";
import IP from "../config/config"
// ------------- 足球资料库 ---------------
// 资料基本信息
export function getSclassBase (param) {
    const url = IP.dcApis() + '/pc/getSclassBase';
    return Ajax(url, param, "GET");
}
// 资料对阵图
export function getScheduleChart (param) {
    const url = IP.mApis() + '/data/league/schedule/chart';
    return Ajax(url, param, "GET");
}
